import * as React from 'react';
import { ResultsPerPage, SearchProvider } from '@elastic/react-search-ui';
import Offcanvas from '../../../faceted-search/react/Offcanvas';
import { FilterButton } from '../../../faceted-search/react/helper';
import SearchRoot from '../SearchRoot';
import { hiddenFacets, providerConfig } from '../../helper';
import {
  OpenSearchActiveFilters,
  OpenSearchClearAllFiltersButton,
  OpenSearchPagination,
  OpenSearchResultsCount,
  OpenSearchSearchBox,
} from '../components';
import { SearchResult } from '../search-results';
import { CompactLayoutFilters, StandardLayoutFilters } from './index';

// Horizontal layout: filters as a top bar with full-width results below (suits wide
// tables). On mobile the inline filters collapse into an Offcanvas opened by the filter
// button, leaving a compact bar of search box + button — mirrors the standard layout's
// mobile pattern. Breakpoint visibility is handled in partials/open-search/_filters.scss.
export default function HorizontalLayout(props) {
  const {
    connector,
    config = {},
    css = {},
    trackUrlState = true,
    showSearchBox,
  } = props;
  const {displayOptions, ViewMode} = config;
  const {itemsPerPage} = displayOptions;

  const hiddenFacetsList = React.useMemo(() => hiddenFacets(config?.facets), [config?.facets]);

  return (
    <div className={css?.root}>
      <SearchProvider config={{...providerConfig(config), apiConnector: connector, trackUrlState: trackUrlState}}>
        <SearchRoot>
          <Offcanvas title={'Filters'} callback={() => {document.querySelector('.nv-open-search button.clear-filters')?.click();}}>
            {/* Force checkbox facets — a flat list suits the offcanvas, whereas the inline
                bar's dropdowns would render a dropdown-inside-a-drawer here. */}
            <StandardLayoutFilters facets={config?.facets} forceCheckbox/>
          </Offcanvas>

          <div className='horizontal-filters'>
            <div className='horizontal-filters__inline'>
              <CompactLayoutFilters facets={config?.facets}/>
            </div>
            {showSearchBox && (
              <div className='horizontal-filters__search'>
                <OpenSearchSearchBox/>
              </div>
            )}
            <div className='horizontal-filters__switcher'>
              <FilterButton/>
            </div>
          </div>

          <div className='active-filters-panel'>
            <OpenSearchClearAllFiltersButton/>
            <OpenSearchActiveFilters facets={config?.facets} hiddenFacets={hiddenFacetsList}/>
          </div>

          <SearchResult viewMode={ViewMode}/>

          <div className='row search-stats__footer'>
            <div className='col-lg-6 col-sm-12 d-flex align-items-center justify-content-start footer-col'>
              <OpenSearchResultsCount/>
            </div>
            <div className='col-lg-6 col-sm-12 footer-col'>
              <OpenSearchPagination/>
            </div>
          </div>
          <div className='d-none'>
            <ResultsPerPage options={[itemsPerPage]}/>
          </div>
        </SearchRoot>
      </SearchProvider>
    </div>
  );
}
